import { useApi } from "../../../../../customer-experience/src/v2/src/utils";
import {
  RoadmapDto,
  RoadmapsClient,
} from "../../../../../customer-experience/src/lib/ShiOneClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTracking } from "../../../contexts";
import { FeatureDefinitions } from "../../../utils/FeatureDefinitions";
import { CACHE_KEY_ROADMAPS_OVERVIEW } from "../utils/constants";

export default function useCreateRoadmap(
  setShowSnackbar?: (param: boolean) => void,
  setSnackbarMessage?: (param: string) => void,
) {
  const api = useApi(RoadmapsClient);
  const queryClient = useQueryClient();
  const { trackEvent } = useTracking();

  return useMutation({
    mutationFn: async (roadmap: RoadmapDto) => {
      return await api.createRoadmap(roadmap);
    },
    onSuccess: () => {
      trackEvent?.("RoadmapCreated", {
        relatedFeature: FeatureDefinitions.ITRoadmaps_ITRoadmaps,
        isMetricsTracking: true,
      });
    },
    onError: async () => {
      setSnackbarMessage?.(
        "There was an issue creating the item, please try again later.",
      );
      setShowSnackbar?.(true);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries([CACHE_KEY_ROADMAPS_OVERVIEW]);
    },
  });
}
